/* eslint-disable react/prop-types */
import React from 'react';
import BadesulInputHandler from './InputHandler';
import BadesulSocietyForm from './BadesulSocietyForm';
import BadesulAddress from './BadesulAddressWrapper';

const StepHandler = ({
  fullStep,
  selectedBusinessUser,
  isLoading,
  business,
  setUpdateState,
  form,
  inputsFromDatabase,
  mutations,
  creatingCivilPartner,
}) => {
  const components = {
    BadesulSocietyForm,
    BadesulAddress,
  };

  if (fullStep.component) {
    return (
      components[fullStep.component]({
        business,
        selectedBusinessUser,
        mutations,
        form,

        societyData: selectedBusinessUser?.user?.additionalInfo?.societyData,
        saveSocietyMutation: mutations.saveBusinessUser,
      }) ?? null
    );
  }

  return (
    <>
      {fullStep.inputs
        .filter((input) => {
          if (!input.showIf) {
            return true;
          }

          const shouldShowInput = input.showIf(selectedBusinessUser, {
            creatingCivilPartner,
            formValues: form.getFieldsValue(),
          });

          return shouldShowInput;
        })
        .map((input) => (
          <BadesulInputHandler
            key={input.value}
            input={input}
            loading={isLoading}
            selectedBusinessUser={selectedBusinessUser}
            business={business}
            onUpdate={setUpdateState}
            mutations={mutations}
            form={form}
            inputsFromDatabase={inputsFromDatabase}
          />
        ))}
    </>
  );
};

export default StepHandler;
